var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPodium2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "mout_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 345.9 131.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #f89742;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M330.5,67.1c20.1,41.2,13.6,60,15.1,64.2,0,.4.6,0,0,0-6,0-17.2.1-22.1.1-18.5,0-32.9,0-56.7,0H105.8c-58,0-69.2,0-103,0-4.7,0-3.1-11.6,2.2-24.4C56.1,42.5,114.8,9.2,172.7,0c46.8-1.2,111,29.3,113.5,30.6,24.8,15.9,40.9,29.5,44.3,36.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPodium2);
export default __webpack_public_path__ + "static/media/podium_2.042385563e8b95df9ffa6a272acef68a.svg";
export { ForwardRef as ReactComponent };